module.exports = __webpack_public_path__ + "static/media/user-friends.e5694bff.svg";